import { formatCurrency, getCurrencyFormat, getCurrencySymbol } from './currency.js';
const parseAmount = (amount) => {
    if (typeof amount === 'number')
        return amount;
    if (typeof amount === 'string') {
        return parseFloat(amount.replace(/[,_]/gu, ''));
    }
    throw new Error('unexpected price type');
};
export const formatPrice = (price, { useGrouping = true, currency = 'USD', format, maxFraction = 2, } = {}) => {
    const priceNumber = parseAmount(price);
    const currencySymbol = getCurrencySymbol(currency);
    const currencyFormat = format || getCurrencyFormat(currency);
    const result = formatCurrency(priceNumber, {
        minFraction: priceNumber === 0 ? 0 : Math.min(maxFraction, 2),
        maxFraction: priceNumber === 0 ? 0 : maxFraction,
        format: currencyFormat,
        symbol: currencySymbol,
        useGrouping,
    });
    if (parseFloat(result.replace(currencySymbol || '', '')) === 0) {
        return formatCurrency(0, {
            minFraction: 0,
            maxFraction: 0,
            format: currencyFormat,
            symbol: currencySymbol,
            useGrouping,
        });
    }
    return result;
};
export function formatPriceUSD(price) {
    return formatPrice(price);
}
export function formatAssetPrice({ price, currency, decimals: decimalsFromProps, }) {
    return formatPrice(price.toString(), {
        currency,
        maxFraction: decimalsFromProps || getFiatAdaptiveFraction(price),
        useGrouping: true,
    });
}
export const getFiatAdaptiveFraction = (price) => {
    price = Number(price);
    return price === 0 ? 2 : price >= 1 ? 2 : price >= 0.0001 ? 4 : 6;
};
